import React from 'react';

interface MetricsCardProps {
  title: string;
  value: number | string;
  suffix?: string;
  trend?: 'up' | 'down' | 'neutral';
  icon?: string;
}

export function MetricsCard({
  title,
  value,
  suffix,
  trend,
  icon,
}: MetricsCardProps) {
  const trendColors = {
    up: 'text-green-600',
    down: 'text-red-600',
    neutral: 'text-gray-600',
  };

  const trendIcons = {
    up: '↑',
    down: '↓',
    neutral: '→',
  };

  return (
    <div className="bg-white rounded-lg p-6 border border-gray-200 hover:shadow-md transition-shadow">
      <div className="flex items-start justify-between mb-4">
        <h3 className="text-sm font-medium text-gray-600">{title}</h3>
        {icon && <span className="text-2xl">{icon}</span>}
      </div>
      <div className="flex items-baseline space-x-2">
        <span className="text-3xl font-bold text-gray-900">{value}</span>
        {suffix && <span className="text-lg text-gray-500">{suffix}</span>}
      </div>
      {trend && (
        <div className={`mt-2 flex items-center text-sm ${trendColors[trend]}`}>
          <span className="mr-1">{trendIcons[trend]}</span>
          <span className="capitalize">{trend}</span>
        </div>
      )}
    </div>
  );
}
